"use client";

import Image from "next/image";
import { motion } from "framer-motion";
export default function InfoSection() {
  const missionVisionData = [
    {
      title: "Mission",
      subtitle: "모두를 위한 포용적 기술",
      content: [
        "위즈온은 포용적 기술로 사회적 가치를 실현하는 IT 기업입니다.",
        "장애인과 비장애인 개발자가 함께 설립해,",
        "정보 접근성과 디지털 격차 해소를 위한 솔루션을 개발하고 있습니다.",
      ],
    },
    {
      title: "Vision",
      subtitle: "일상을 바꾸는 지속 가능한 디지털 혁신",
      content: [
        "일상의 문제를 발굴해 실질적인 기술로 연결하고,",
        "이를 지속 가능한 비즈니스로 확장하며",
        "모두를 위한 디지털 혁신을 만들어가고 있습니다.",
      ],
    },
  ];
  return (
    <div className="border-t border-[#ECECEC] mt-[-2px]">
      <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20">
        <div className="flex flex-col md:flex-row justify-between gap-5">
          {missionVisionData.map((item, idx) => (
            // <motion.div
            //   key={idx}
            //   className="flex-1 w-full flex-col justify-center self-center items-center rounded-4xl bg-light-10 py-6 px-5 md:py-10 md:px-10 xl:px-12 xl:py-12 border border-light-20 text-center"
            //   initial={{ opacity: 0, y: 20 }}
            //   whileInView={{ opacity: 1, y: 0 }}
            //   viewport={{ once: true, amount: 0.3 }}
            //   transition={{ duration: 0.8, delay: idx * 0.2 }}
            // >
            <div
              key={idx}
              className="flex-1 w-full flex-col justify-center self-center items-center rounded-4xl bg-light-10 py-6 px-5 md:py-10 md:px-10 xl:px-12 xl:py-12 border border-light-20 text-center"
            >
              <span
                className="text-white bg-[#398285] leading-6  px-4 py-1.5 md:py-2 rounded-full  inline-flex text-sm md:text-base self-center justify-center items-center"
                style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
              >
                {item.title}
              </span>
              <p
                className="text-[#398285] my-5 md:my-6 xl:my-12 text-xl md:text-3xl text-center tracking-tight"
                style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              >
                {item.subtitle}
              </p>
              <div
                className="tracking-tighter text-midGray-50 text-base leading-6 md:text-xl md:leading-9 text-center"
                style={{
                  fontFamily: '"pre-Regular", sans-serif',
                  wordBreak: "keep-all",
                }}
              >
                {item.content.map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>
            </div>
            // </motion.div>
          ))}
        </div>

        <div className="mt-10 md:mt-20 mx-auto flex justify-center">
          <motion.div
            className="w-4 h-10 md:w-8 md:h-20 relative"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <Image
              src="/assets/images/icon/arrow-down.svg"
              alt="Symbol Logo"
              fill
              style={{ objectFit: "cover" }}
            />
          </motion.div>
        </div>
      </div>

      <motion.div
        className="bg-[#398285]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20 justify-center items-center flex flex-col">
          <span
            className="text-sm md:text-base leading-6 px-4 py-1.5 md:py-2 rounded-full flex flex-row text-[#398285] bg-white justify-self-start tracking-tight"
            style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
          >
            Goal
          </span>
          <p
            className="text-2xl md:text-3xl text-white mt-5 tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            모두를 위한 더 나은 세상
          </p>
        </div>
      </motion.div>
    </div>
  );
}
